<div class="program-selector-wrapper">
  <div class="start-header">
    <h6>Choose a product</h6>
  </div>

  <div class="selector-body">
    <!-- LEFT: product list -->
    <div class="selector-left">
      <section class="group">
        <p class="group-sublabel">
          <strong>Green Shield </strong> 
            &nbsp; Quotes natively in Compass 
          </p>

        <div
          class="option-card option-card--row"
          [class.selected]="selected === guardianElite.id"
          (click)="select(guardianElite.id)"
        >
          <span
            class="option-icon"
            [ngStyle]="{
              'mask-image': 'url(' + guardianElite.icon + ')',
              '-webkit-mask-image': 'url(' + guardianElite.icon + ')'
            }"
          ></span>

          <div class="option-body">
            <h3>{{ guardianElite.name }}</h3>
            <p>{{ guardianElite.description }}</p>
            <span class="pill pill-low" *ngIf="guardianElite.recommended">
              
              <i class="pi pi-check  check-pill"></i>&nbsp; Recommended
            </span>
          </div>
          <i class="pi pi-chevron-right"></i>
        </div>
      </section>

      <!-- only this section scrolls internally; the Green Shield card above never does -->
      <section class="group group--specialty">
        <p class="group-sublabel speciality">
          <strong>Specialty Programs</strong>
          
          Backed by AU Gold 
          <span class="pill pill-empty pdt">{{ specialtyProducts.length }} Products</span>
        </p>
        <div class="divider"></div>
        <div class="card-list" #cardList>
          <div
            class="option-card option-card--row"
            *ngFor="let product of specialtyProducts"
            [class.selected]="selected === product.id"
            [attr.data-id]="product.id"
            (click)="select(product.id)"
          >
            <span
              class="option-icon"
              [ngStyle]="{
                'mask-image': 'url(' + product.icon + ')',
                '-webkit-mask-image': 'url(' + product.icon + ')'
              }"
            ></span>

            <div class="option-body">
              <h3>{{ product.name }}</h3>
              <p>{{ product.description }}</p>
            </div>
            <i class="pi pi-chevron-right"></i>
          </div>
        </div>
      </section>
    </div>

    <!-- <div class="v-divider"></div> -->

    <!-- RIGHT: live preview of whatever is currently selected -->
    <div class="selector-wrapper-right">
    <div class="selector-right">
      <ng-container *ngIf="selectedProduct; else emptyState">
        <h4 class="detail-title">{{ selectedProduct.detail.title }}</h4>
        <p class="detail-subtitle">{{ selectedProduct.detail.subtitle }}</p>

        <div class="limits-grid" *ngIf="selectedProduct.detail.productDescription">
          <div
            class="limit-item"
            *ngFor="let limit of selectedProduct.detail.productDescription"
          >
            <span class="limit-label">{{ limit.label }}</span>
            <span class="limit-value">{{ limit.value }}</span>
          </div>
        </div>

        <div class="tag-row">
          <span class="pill pill-empty" *ngFor="let tag of selectedProduct.detail.tags">{{
            tag
          }}</span>
        </div>

        <div class="divider"> </div>

        <h5 class="section-label">Key Coverage Limits</h5>
        <div class="limits-grid">
          <div
            class="limit-item"
            *ngFor="let limit of selectedProduct.detail.keyLimits"
          >
            <span class="limit-label">{{ limit.label }}</span>
            <span class="limit-value">{{ limit.value }}</span>
          </div>
        </div>
        <div
            class="info-tag"
            *ngIf="selectedProduct.detail.infoTag"
          >
            {{ selectedProduct.detail.infoTag }}
          </div>
        <div class="divider"> </div>

        <h5 class="section-label">Ineligible</h5>
        <p class="ineligible-text">{{ selectedProduct.detail.ineligible }}</p>
      </ng-container>
   
      <ng-template #emptyState>
        <div class="empty-state">
          <p>Select a product on the left to preview its details here.</p>
        </div>
      </ng-template>
    </div></div>
  </div>

  <div class="actions">
    <button class="outline btn-md" (click)="cancel()">Cancel</button>
    <button class="primary btn-md" [disabled]="!selected" (click)="continue()">
      Continue
    </button>
  </div>
</div>